import React, { useState, useContext } from 'react';
import { EyeIcon, EyeOffIcon } from '@heroicons/react/outline'; 
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from './App';

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { setAuth } = useContext(AuthContext);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleLogin = (e) => {
        e.preventDefault();
        axios.post('https://api.finaloffers.fyi/auth/login', { email, password })
            .then(response => {
                console.log("Login successful", response.data);
                localStorage.setItem('isLoggedIn', true);
                localStorage.setItem('user', response.data.userId);
                localStorage.setItem('email', email); // Store email in localStorage
                setAuth({ isLoggedIn: true, user: response.data.userId, email: email  });
                navigate('/');
            })
            .catch(error => {
                console.error("Login failed", error.response.data);
                setError(error.response.data.message);
            });
    };

    return (
        <div className='flex justify-center items-center mt-10'>
            <div className='border border-black rounded shadow-solid h-80'>
            <div className='justify-center text-center w-full mt-4 font-bold text-lg'>Log in</div>
            <form className='w-96 max-w-xs p-6 rounded' onSubmit={handleLogin}>
                
                <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className='items-center w-full rounded h-8 text-sm focus:ring-0 border-black focus:border-black'
                />
                <div className="relative">
                    <input
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        className={`items-center w-full rounded mt-4 h-8 text-sm focus:ring-0 border-black focus:border-black pr-10 `}
                    />
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pt-4">
                        {showPassword ? (
                            <EyeOffIcon className="h-5 w-5 text-gray-500 cursor-pointer" onClick={togglePasswordVisibility} />
                        ) : (
                            <EyeIcon className="h-5 w-5 text-gray-500 cursor-pointer" onClick={togglePasswordVisibility} />
                        )}
                    </div>
                </div>
                
                <div className='text-right text-xs mt-1'>
                    {error === "We found the email, but the password doesn't match." 
                        ? (
                            <div className='inline-flex'><p> Password doesn't match. &nbsp;</p>
                            <a href="/forgot-password" className='text-blue-600 underline'>Reset password?</a></div>
                        ) 
                        : (
                            <a href="/forgot-password" className='text-blue-600 underline'>Forgot your password?</a>
                        )
                    }
                </div>
                <button className='items-center w-full bg-black text-white rounded mt-12 h-8 text-sm cursor-pointer' type="submit">Login</button>
                

                <div className='flex w-full justify-center items-center mt-6'>
                    {error
                        ? (error === "Email not found." && (
                             <p className='text-xs text-center'>Email not found.&nbsp;
                                <a href="/signup" className='text-blue-600 underline'>Create account</a>
                            </p>))
                        : (
                            <p className='text-xs text-center'>No account?&nbsp;
                                <a href="/signup" className='text-blue-600 underline'>Create one</a>
                            </p>
                        )
                    }
                </div>


            </form>
            </div>
        </div>
        
    );
}

export default Login;

                {/* <div className='inline-flex w-full content-center mt-6'>
                    <p className='text-xs text-center'>No account? &nbsp;</p>
                    <a href="/signup" className='text-xs text-blue-600 underline'>Create one</a>
                </div> */}
                {/* <div className='flex w-full justify-center items-center mt-6'>
                    {error === "Email not found." && (
                        <p className='text-xs'> Em.&nbsp;</p>
                    )}
                    <p className='text-xs text-center'>No account?&nbsp;</p>
                    <a href="/signup" className='text-xs text-blue-600 underline'>Create one</a>
                </div> */}

// import React, { useState, useContext } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { AuthContext } from './App';

// function Login() {
//     const [email, setEmail] = useState('');
//     const [password, setPassword] = useState('');
//     const [error, setError] = useState('');

//     const navigate = useNavigate();
//     const { setAuth } = useContext(AuthContext);

//     const handleLogin = async (e) => {
//         e.preventDefault();
//         axios.post('http://localhost:5000/auth/login', { email, password })
//             .then(response => {
//                 console.log("LogIn successful", response.data);
//                 setAuth({ isLoggedIn: true, user: response.data.userId });
//                 navigate('/');
//             })
//             .catch(error => {
//                 console.error("LogIn failed", error.response.data);
//             });
//         // try {
//         //     const response = await axios.post('/auth/login', { email, password });
//         //     setAuth({ isLoggedIn: true, user: response.data.user });
//         //     navigate('/');
//         // } catch (error) {
//         //     console.error(error);
//         // }
//     };

//     return (
//         <form onSubmit={handleLogin}>
//             <input
//                 type="email"
//                 placeholder="Email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 required
//             />
//             <input
//                 type="password"
//                 placeholder="Password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 required
//             />
//             <button type="submit">Login</button>
//         </form>
//     );
// }

// export default Login;
